import styled from 'styled-components';

export const Group = styled.div`
  text-align: left;
  
  ${({type}) => type === 'image' && `
    display: flex;
    flex-wrap: wrap;
  `}
`;